import { isValidEmailAddress, isValidPassword } from '../functions';


$(document).ready(function() {

    var isLoadingLogin = false;
    $(document).on('click', '#login-btn', function() {

        if (isLoadingLogin) {
            console.log('is loading...');
            return false;
        }

        $('#login-form').find('.form-error-msg').html('');
        $('#login-form').find('.has-error').removeClass('has-error');

        var errorsFields = false;
        var errorsEmailInvalid = false;

        if($('#login_email').val() == '') {
            errorsFields = true;
            $('#login_email').parent().addClass("has-error");
        } else if(!isValidEmailAddress($('#login_email').val())) {
            errorsEmailInvalid = true;
            $('#login_email').parent().addClass("has-error");
        }
        if($('#login_password').val() == '') {
            errorsFields = true;
            $('#login_password').parent().addClass("has-error");
        }

        if (errorsFields) {
            $('#login-form').find(".form-error-msg").html("נא למלא את כל השדות המסומני").attr('role', 'alert');
            return false;
        } else if(errorsEmailInvalid) {
            $('#login-form').find(".form-error-msg").append("<div>נא למלא שדה אימייל תקין</div>").attr('role', 'alert');
            $('#login_email').focus();
            return false;
        }

        //Loading...
        isLoadingLogin = true;
        $('#login-btn').append('<i class="fa fa-spinner fa-spin" style="margin-right: 20px"></i>');

        var values = '_token=' + $('#_token_login').val();
		values += '&email=' + $('#login_email').val();
		values += '&password=' + $('#login_password').val();
		values += '&remember=' + ($('#login_remember').is(':checked')?1:0);
		$.ajax({
            type: "POST",
            url: baseURL + "/login",
            data: values,
            success: function(response) {
                isLoadingLogin = false;
                $('#login-btn').find('i').remove();

				if (response.status == 0) {
					var errorHtml = '';
					for(var errorKey in response.errors) {
						if(!response.errors.hasOwnProperty(errorKey)) continue;
						for(var error in response.errors[errorKey]) {
							$("#login_"+errorKey).parent().addClass('has-error');
							errorHtml += response.errors[errorKey][error] + '<br>';
						}
					}

					$('#login-form').find(".form-error-msg").html('<div>'+errorHtml+'</div>').attr('role', 'alert');
					return false;
				}

				if (response.status == 1) {

                    location.reload();

                    return false;
				}

                $('#login-form').find(".form-error-msg").html('<div>שגיאה: משהו השתבש, אנא צור קשר עם מנהל מערכת</div>').attr('role', 'alert');
            },
            error(error) {
                isLoadingLogin = false;
                $('#login-btn').find('i').remove();
                $('#login-form').find(".form-error-msg").html('<div>שגיאה: משהו השתבש, אנא צור קשר עם מנהל מערכת</div>').attr('role', 'alert');
            }
        });
    });

});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/login.js